/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useContext, useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { extend } from '@thd-nucleus/data-sources';
import {
  number, string, func, bool, shape, object, arrayOf
} from 'prop-types';
import { ExperienceContext, useStore, useConfigService } from '@thd-nucleus/experience-context';
import { CheckAvailability } from '@thd-olt-component-react/check-availability';
import { shipping } from '@thd-olt-component-react/delivery-options';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { dataModel } from '../dataModel';
import { PickupHeader } from './PickupHeader';
import { DeliveryHeader } from './DeliveryHeader';
import { PickupTile } from './PickupTile';
import { DeliveryTile } from './DeliveryTile';
import { DualPath } from '../shared/DualPath/DualPath';
import { NotifyMe } from '../shared/NotifyMe/NotifyMe';
import { LiveGoods } from '../shared/LiveGoods/LiveGoods';
import { ItemUnavailable } from '../shared/ItemUnavailable/ItemUnavailable';
import {
  useFulfillmentGetData,
  useShippingGetData,
  useApplianceGetData,
} from '../../hooks/useFulfillmentTiles';
import { getFulfillmentInfoFromData } from '../../hooks/useFulfillmentGetTemplates';
import { useFulfillmentListeners } from '../../hooks/useFulfillmentListeners';
import { useHandleOnChange } from '../../hooks/useHandleOnChange';
import { Discontinued } from '../shared/Discontinued/Discontinued';
import { FulfillmentPlaceholder } from './Placeholder/FulfillmentPlaceholder';
import {
  getLiveGoodsStock,
  setDeliveryZip,
  getDeliveryZip,
  isNonMajorAppliance,
  getPickupStoreName,
  isMobile,
  getLocalStore,
  bopis,
  sth,
  bodfs,
  getExcludedStateName,
  isMajorApplianceProductType,
  isBackorderedSelection,
  isExchangeCustomerFallback,
  isBopisNotFulfillableOOS,
  boss,
  isActiveOrInSeason,
  isItemOnClearance,
  isBopisFalse,
  isExchangeItemUnavailable
} from '../helper/utils';
import { isSthInStock } from '../../pod/helpers/pod-fulfillment-utils';
import './fulfillmentTiles.scss';
import { FULFILLMENT_METHODS } from '../constants';
import { CheckNearByStore } from './partials/store/CheckNearByStore';
import { DeliveryMessageUnderTile } from './DeliveryMessageUnderTile';
import { ExcludedShipState } from './ExcludedShipState/ExcludedShipState';
import { ApplianceAlerts } from './alerts/ApplianceAlerts';
import { NonMajorApplianceAlert } from './alerts/NonMajorApplianceAlert';
import useSelectedFulfillmentHasChanged from '../../hooks/useSelectedFulfillmentHasChanged';
import { ClearancePickupMessageUnderTile } from './partials/store/ClearancePickupMessageUnderTile';

const FulfillmentTiles = (props) => {
  const {
    itemId,
    lineItemId,
    storeId,
    deliveryZip,
    quantity,
    originalConfigId,
    covidAlert,
    dualPath,
    category,
    onChange,
    onDeliveryZipCodeChange,
    thresholds,
    directData,
    applianceDirectData,
    configurableApplianceItemIds,
    isBuyBoxLite,
    isCartTiles,
    localizerStoreDetails,
    quantityExceeded,
    addOnsAssemblyAndMore,
    cartAction,
    bypassQuantitySkip = false,
    disableSTH,
    disableBODFS,
    disableBOSS,
    openApplianceCheckAvailability,
    disablePickupNearBy,
    currentSelectedFulfillment,
    leadTime,
    hasCustomATC,
    configurableProductDetails,
    hideShippingThreshold
  } = props;
  const theme = useTheme(FulfillmentTiles);
  const { hideDeliveryMessageUnderTile } = theme.props;
  const { channel, isConsumerApp } = useContext(ExperienceContext);
  const enableApplianceDeliveryCharge = useConfigService('enableApplianceDeliveryCharge') || false;
  const enableFreeDeliveryForExchange = useConfigService('enableFreeDeliveryForExchange') || false;
  let { isExchangeCustomer } = useThdCustomer() || {};
  if (typeof isExchangeCustomer === 'undefined') isExchangeCustomer = isExchangeCustomerFallback();
  const { storeId: defaultStoreId, storeName: defaultStoreName, storeZip } = useStore();
  const storeName = getPickupStoreName(directData) || defaultStoreName || '';
  const [zipCode, setZipCode] = useState(deliveryZip || getDeliveryZip() || storeZip);
  const [selectedFulfillmentMethod, setSelectedFulfillmentMethod] = useState(
    currentSelectedFulfillment
  );
  const [showCheckAvailability, setShowCheckAvailability] = useState(false);
  const [ffmData, setFfmData] = useState({});
  const [secondaryFFM, setPreferSecondaryFFM] = useState({
    isServiceOptedIn: false,
    prefer: false,
  });
  const [applianceDeliveryData, setApplianceDeliveryData] = useState(
    isCartTiles && applianceDirectData ? applianceDirectData : null
  );
  const [isNativeDeliveryZipEventTriggered, setIsNativeDeliveryZipEventTriggered] = useState(false);
  const currentDeliveryFfm = useRef('');
  const numberOfAddOnsAndMore = addOnsAssemblyAndMore
    ? Object.keys(addOnsAssemblyAndMore).length
    : 0;
  const updateZipCode = (newZipCode) => {
    if (newZipCode) {
      setDeliveryZip(newZipCode);
      setZipCode(newZipCode);
    }
  };
  const [updatedQuantity, setQuantityToQuery] = useState(quantity);

  const onChangeOfZipCode = (data) => {
    const shippingModel = shipping(data?.shipping);
    updateZipCode(data?.shipping?.zipCode);
    // setShippingModel(updatedModel);
    if (shippingModel) {
      if (onDeliveryZipCodeChange) {
        onDeliveryZipCodeChange(
          isCartTiles
            ? data?.shipping?.zipCode
            : { ...shippingModel, zipCode: data?.shipping?.zipCode }
        );
      }
    }
  };
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.on('NATIVE_APP.DELIVERY_ZIP', ({ output }) => {
      if (output?.deliveryZip) {
        setZipCode(output?.deliveryZip);
      }
      setIsNativeDeliveryZipEventTriggered(true);
    });
    let deliveryZipEventTimer;
    if (isConsumerApp && !isCartTiles) {
      deliveryZipEventTimer = setTimeout(() => {
        setIsNativeDeliveryZipEventTriggered((isTriggered) => {
          if (!isTriggered) {
            if (typeof window !== 'undefined' && window.newrelic) {
              window.newrelic.addPageAction(
                'DeliveryZip was not received by fulfillment component from native app within 7 seconds.',
                {
                  id: 'fulfillment',
                  name: '',
                  message: '',
                  stack: '',
                }
              );
            }
            return true;
          }
          return isTriggered;
        });
      }, 7000);
    }
    return () => {
      if (deliveryZipEventTimer) {
        clearTimeout(deliveryZipEventTimer);
      }
    };
  }, []);

  useEffect(() => {
    // for cart
    if (isCartTiles) {
      setZipCode(deliveryZip);
    }

    // call to set quantity with a delay
    const timer = setTimeout(() => {
      // Update the quantity after a wait so as to avoid unnecessary re-renders.
      const { fulfillment = {} } = ffmData;
      const { fallbackMode = false } = fulfillment || {};
      if (!fallbackMode && !quantityExceeded) {
        setQuantityToQuery(quantity);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [deliveryZip, isCartTiles, quantity, ffmData.fulfillment]);

  const { data, error, loading } = useFulfillmentGetData({
    itemId,
    zipCode,
    storeId: storeId || defaultStoreId,
    directData,
    // send updated Quantity set after a delay to improve performance
    quantity: updatedQuantity,
    bypassQuantitySkip,
  });

  const isMajorAppliance = !!applianceDirectData
    || !!applianceDeliveryData
    || isMajorApplianceProductType(data?.product?.identifiers?.productType);

  const { shippingData, shippingLoading } = useShippingGetData({
    itemId,
    storeId: storeId || defaultStoreId,
    zipCode,
    quantity: updatedQuantity,
    value: data?.product?.pricing?.value,
    isSthAvailable: sth(data?.product?.fulfillment),
    directData,
    isMajorAppliance,
    configId: originalConfigId
  });

  useApplianceGetData({
    itemId,
    itemIds: configurableApplianceItemIds,
    storeId: storeId || defaultStoreId,
    zipCode,
    isMajorAppliance,
    applianceDirectData,
    setApplianceDeliveryData,
  });

  // for cart tiles, need to preserve selected ffm on initial load
  const getCurrentDeliveryFfm = () => {
    if (!currentDeliveryFfm?.current && isCartTiles) {
      return selectedFulfillmentMethod;
    }
    return currentDeliveryFfm?.current;
  };

  useEffect(() => {
    if (data?.product) {
      setFfmData(
        getFulfillmentInfoFromData({
          data,
          itemId,
          covidAlert,
          quantity,
          originalConfigId,
          zipCode,
          storeId: storeId || defaultStoreId,
          storeName,
          channel,
          thresholds,
          setShowCheckAvailability,
          currentDeliveryFfm: getCurrentDeliveryFfm(),
          shippingData,
          isMajorAppliance,
          applianceDeliveryData,
          preferSecondaryFFM: secondaryFFM.prefer,
          isCartTiles,
          addOnsAssemblyAndMore,
          disableSTH,
          disableBODFS,
          disableBOSS,
          disablePickupNearBy,
          enableApplianceDeliveryCharge,
          enableFreeDeliveryForExchange,
          isExchangeCustomer,
          isSpecialOrder: configurableProductDetails.isSpecialOrder,
          configuratorHideQuantity: configurableProductDetails.configuratorHideQuantity,
          isConfigurableBlinds: configurableProductDetails.isConfigurableBlinds,
          disableTimer: configurableProductDetails.disableTimer,
          hideShippingThreshold
        })
      );
    }
  }, [
    data.product,
    quantity,
    shippingData,
    applianceDeliveryData,
    secondaryFFM,
    numberOfAddOnsAndMore,
    configurableProductDetails.isSpecialOrder,
    configurableProductDetails.disableTimer,
    configurableProductDetails.configuratorHideQuantity,
    configurableProductDetails.isConfigurableBlinds
  ]);

  const {
    fulfillment = {},
    info,
    identifiers,
    value,
    availabilityType,
    fulfillmentModels,
    optimalFulfillmentFromAPI,
  } = ffmData;

  const isClearanceItem = isItemOnClearance(fulfillment) && data?.product?.pricing?.clearance;
  const { fallbackMode = false } = fulfillment || {};
  const isBackorderedApplied = isBackorderedSelection(fulfillment?.backordered, selectedFulfillmentMethod);
  const getCurrentFulfillment = (selectedFulfillment, ffms) => {
    if (selectedFulfillment) {
      return ffms.find((option) => option.method === selectedFulfillment);
    }
    return fulfillmentModels.find((option) => option.method === selectedFulfillment);
  };

  const { pushNewFulfillmentMethod } = useSelectedFulfillmentHasChanged();

  const isPickupFfmMethod = (currentFulfillmentMethod = '') => {
    return !!(
      currentFulfillmentMethod === FULFILLMENT_METHODS.BOPIS
      || currentFulfillmentMethod === FULFILLMENT_METHODS.BOSS
      || !currentFulfillmentMethod
    ); // on page load variable will be empty
  };

  useEffect(() => {
    if (fulfillmentModels) {
      const currentFulfillment = getCurrentFulfillment(
        selectedFulfillmentMethod,
        fulfillmentModels
      );
      const currentFulfillmentMethod = currentFulfillment?.method || selectedFulfillmentMethod;
      const [storeObj = {}, shippingObj = {}] = fulfillmentModels;
      currentDeliveryFfm.current = shippingObj?.method;
      if (!currentFulfillment?.enabled) {
        if (info?.hasSubscription && shippingObj?.enabled && isSthInStock(data?.product)) {
          setSelectedFulfillmentMethod(shippingObj.method);
        } else if (
          storeObj?.enabled
          && isPickupFfmMethod(currentFulfillmentMethod)
          && !storeObj?.isPickupNearby
        ) {
          setSelectedFulfillmentMethod(storeObj.method);
        } else if (shippingObj?.enabled) {
          setSelectedFulfillmentMethod(shippingObj.method);
        } else if (storeObj?.enabled && isPickupFfmMethod()) {
          // in case the delivery FFM (currentFFM) is not available, then default to the pickup
          setSelectedFulfillmentMethod(storeObj.method);
        }
      }
    }
  }, [fulfillmentModels, secondaryFFM]);

  useEffect(() => {
    // for open delivery zip overlay from cart
    if (window.LIFE_CYCLE_EVENT_BUS && isCartTiles) {
      window.LIFE_CYCLE_EVENT_BUS.off('cart.delivery-zip-modal');
      window.LIFE_CYCLE_EVENT_BUS.on('cart.delivery-zip-modal', () => {
        setShowCheckAvailability(true);
      });
    }
  }, [cartAction]);

  useHandleOnChange({
    onChange,
    getCurrentFulfillment,
    fulfillmentModels,
    availabilityType,
    selectedFulfillmentMethod,
    itemId,
    quantity,
    primaryStoreNum: applianceDeliveryData?.primaryStrNbr,
    isCartTiles,
    isBackorderedApplied,
  });

  useFulfillmentListeners({
    fulfillmentModels,
    setSelectedFulfillmentMethod,
    setPreferSecondaryFFM,
    optimalFulfillmentFromAPI,
  });

  if (
    !fulfillmentModels
    || (isMajorAppliance && !applianceDeliveryData)
    || (isConsumerApp && !isNativeDeliveryZipEventTriggered && !isCartTiles)
  ) {
    return <FulfillmentPlaceholder channel={channel} />;
  }

  const [storeObj = {}, shippingObj = {}] = fulfillmentModels;

  const checkAvailabilityComponent = (
    <span data-testid="check-availability">
      <CheckAvailability
        useDrawerModal
        showCheckAvailability={showCheckAvailability}
        setShowCheckAvailability={setShowCheckAvailability}
        itemId={itemId}
        price={parseInt((value * quantity).toFixed(2), 10)}
        zipCode={zipCode}
        onSubmitForm={(response) => {
          if (response) {
            onChangeOfZipCode(response);
          }
          setShowCheckAvailability(false);
        }}
        quantity={quantity}
        inputHeaderTitle="Zip Code"
      />

    </span>
  );

  // If not isMajorAppliance & user is an exchange customer & fulfillmentOptions are empty or null,
  // then display a common message for all different items
  if (!isMajorAppliance && isExchangeCustomer && isExchangeItemUnavailable(availabilityType, fulfillment, dualPath, data?.product)) {
    return (
      <ItemUnavailable />
    );
  }

  if (storeObj.excluded && shippingObj.excluded) {
    return (
      <ExcludedShipState
        stateText={getExcludedStateName(fulfillment?.sthExcludedShipState)}
        itemId={itemId}
        originalConfigId={originalConfigId}
        checkAvailabilityComponent={checkAvailabilityComponent}
        showCheckAvailability={showCheckAvailability}
        setShowCheckAvailability={setShowCheckAvailability}
        addOnsAssemblyAndMore={addOnsAssemblyAndMore}
      />
    );
  }

  if (availabilityType?.discontinued) {
    return <Discontinued />;
  }

  if (getLiveGoodsStock(fulfillment) === 0) {
    return (
      <LiveGoods storeName={storeName} seasonStatusEligible={fulfillment?.seasonStatusEligible} />
    );
  }

  if (dualPath) {
    return <DualPath category={category} />;
  }

  if (
    (storeObj.unavailable && shippingObj.unavailable)
    || (shippingObj.outOfStock && availabilityType?.type === 'Online' && storeObj.outOfStock)
    || (storeObj.outOfStock && availabilityType?.type === 'Shared' && shippingObj.outOfStock)
  ) {
    return (
      <>
        {showCheckAvailability && checkAvailabilityComponent}
        <NotifyMe
          isMajorAppliance={isMajorAppliance}
          showCheckAvailability={showCheckAvailability}
          setShowCheckAvailability={setShowCheckAvailability}
          itemId={itemId}
          store={storeObj}
          shipping={shippingObj}
          skipEmailOptIn={availabilityType?.type === 'Store Only'}
        />
      </>
    );
  }

  const getWrapperClasses = (fulfillmentModel, removeMargin = false) => {
    return classNames({
      card: true,
      u__legal: isMobile(channel),
      'mobile--margin-right': true,
      'card-container': true,
      'u__text--primary': !fulfillmentModel.enabled,
      'card-selected':
        fulfillmentModel.method === selectedFulfillmentMethod && fulfillmentModel.enabled,
      'card-unselected':
        fulfillmentModel.method !== selectedFulfillmentMethod && fulfillmentModel.enabled,
      'card-enabled': fulfillmentModel.enabled,
      'card-unclickable': !fulfillmentModel.enabled,
      'card-info': fulfillmentModel.tooltip,
      'u__m-right-none': removeMargin,
    });
  };

  const showAvailableText = isClearanceItem || isBopisFalse(fulfillment);

  const onFulfillmentMethodChanged = (newMethod) => {
    setSelectedFulfillmentMethod(newMethod);
    pushNewFulfillmentMethod({ selectedFulfillmentMethod: newMethod });
  };

  return (
    <div className="fulfillment-tiles" data-component="FulfillmentTiles">
      <div className="fulfillment-tile-headers">
        {/* TODO: Determine best way to show either store from zipcode or nearby store */}
        <PickupHeader
          storeName={storeName}
          itemId={itemId}
          originalConfigId={originalConfigId}
          quantity={quantity}
          lineItemId={lineItemId}
          pickupUnavailable={
            ((fulfillment?.fulfillmentOptions !== null
              && isBopisNotFulfillableOOS(fulfillment)
              && isActiveOrInSeason(fulfillment))
              || isClearanceItem)
              ? false
              : (fulfillment?.fulfillmentOptions === null
                || (!bopis(fulfillment) && !boss(fulfillment))
                || (getLocalStore(bopis(fulfillment))?.inventory?.isUnavailable && !boss(fulfillment))
                || (getLocalStore(bopis(fulfillment))?.inventory?.isOutOfStock && !boss(fulfillment))
                || (getLocalStore(boss(fulfillment))?.inventory?.isUnavailable && !bopis(fulfillment))
                || (getLocalStore(boss(fulfillment))?.inventory?.isOutOfStock && !bopis(fulfillment)))
                || storeObj?.isPickupNearby || storeObj?.uavl
          }
          isMajorAppliance={isMajorAppliance}
          isCartTiles={isCartTiles}
          localizerStoreName={localizerStoreDetails?.name}
          addOnsAssemblyAndMore={addOnsAssemblyAndMore}
          isExchangeCustomer={isExchangeCustomer}
          storeId={storeId}
          leadTime={leadTime}
          hasCustomATC={hasCustomATC}
          disablePickupNearBy={disablePickupNearBy}
          showAvailableText={showAvailableText}
          isConfigurator={configurableProductDetails?.isConfigurableBlinds}
        />
        <DeliveryHeader
          itemId={itemId}
          zipCode={zipCode}
          showCheckAvailability={showCheckAvailability}
          setShowCheckAvailability={setShowCheckAvailability}
          isCartTiles={isCartTiles}
          lineItemId={lineItemId}
          fulfillmentMethod={selectedFulfillmentMethod}
          applianceCountInCart={
            applianceDirectData?.DeliveryAvailabilityResponse?.deliveryAvailability
              ?.applianceCountInCart
          }
          channel={channel}
          isMajorAppliance={isMajorAppliance}
          openApplianceCheckAvailability={openApplianceCheckAvailability}
        />
      </div>
      <div className="fulfillment__change-zip-container" />
      {showCheckAvailability && checkAvailabilityComponent}
      <div className="fulfillment__content-wrapper card-deck">
        {storeObj.isPickupNearby ? (
          <CheckNearByStore
            itemId={itemId}
            quantity={quantity}
            originalConfigId={originalConfigId}
            lineItemId={lineItemId}
            addOnsAssemblyAndMore={addOnsAssemblyAndMore}
            isCartTiles={isCartTiles}
            storeIdFromCart={storeId}
            leadTime={leadTime}
            hasCustomATC={hasCustomATC}
          >
            <PickupTile
              getWrapperClasses={getWrapperClasses}
              fulfillmentObj={storeObj}
              originalConfigId={originalConfigId}
              lineItemId={lineItemId}
              currentFulfillmentMethod={selectedFulfillmentMethod}
              setSelectedFulfillmentMethod={onFulfillmentMethodChanged}
              isCartTiles={isCartTiles}
            />
          </CheckNearByStore>
        ) : (
          <PickupTile
            getWrapperClasses={getWrapperClasses}
            fulfillmentObj={storeObj}
            originalConfigId={originalConfigId}
            lineItemId={lineItemId}
            currentFulfillmentMethod={selectedFulfillmentMethod}
            setSelectedFulfillmentMethod={onFulfillmentMethodChanged}
            isCartTiles={isCartTiles}
            storeIdFromCart={storeId}
          />
        )}
        <DeliveryTile
          getWrapperClasses={getWrapperClasses}
          fulfillmentObj={shippingObj}
          currentFulfillmentMethod={selectedFulfillmentMethod}
          setSelectedFulfillmentMethod={onFulfillmentMethodChanged}
          lineItemId={directData?.lineItemId}
        />
      </div>
      <div className="fulfillment__fullcontent">
        <ClearancePickupMessageUnderTile
          isClearanceItem={isItemOnClearance(fulfillment)}
          localstore={storeName}
          pricing={data?.product?.pricing}
          isCartTiles={isCartTiles}
          itemId={itemId}
        />
        {getCurrentFulfillment(selectedFulfillmentMethod, fulfillmentModels)?.subTemplate
          && !getCurrentFulfillment(selectedFulfillmentMethod, fulfillmentModels)?.unavailable && (
            <>
              {getCurrentFulfillment(selectedFulfillmentMethod, fulfillmentModels).subTemplate}
              {isNonMajorAppliance(identifiers.productType, info) && <NonMajorApplianceAlert />}
            </>
          )}
        <ApplianceAlerts applianceDeliveryData={applianceDeliveryData} storeObj={storeObj} />
      </div>
      {!fallbackMode && !hideDeliveryMessageUnderTile
        && (
          <DeliveryMessageUnderTile
            shippingData={shippingData}
            bodfsFulfillment={bodfs(fulfillment)}
            currDeliveryTileFfm={shippingObj?.method}
            isShippingLoading={shippingLoading}
            isMajorAppliance={isMajorAppliance}
            applianceDeliveryData={applianceDeliveryData}
            value={value}
            enableApplianceDeliveryCharge={enableApplianceDeliveryCharge}
            enableFreeDeliveryForExchange={enableFreeDeliveryForExchange}
            isExchangeCustomer={isExchangeCustomer}
            isBuyBoxLite={isBuyBoxLite}
            isCartTiles={isCartTiles}
          />
        )}
    </div>
  );
};

FulfillmentTiles.displayName = 'FulfillmentTiles';

FulfillmentTiles.themeProps = {
  hideDeliveryMessageUnderTile: bool
};

FulfillmentTiles.defaultThemeProps = {
  hideDeliveryMessageUnderTile: false
};

FulfillmentTiles.propTypes = {
  /** An Item that has product highlights */
  itemId: string.isRequired,
  storeId: string,
  deliveryZip: string,
  covidAlert: bool,
  quantity: number,
  originalConfigId: string,
  onChange: func,
  dualPath: bool,
  onDeliveryZipCodeChange: func,
  thresholds: shape({
    bodfsMinimumThreshold: number,
    bopisMinimumThreshold: number,
    bopisMinimumThresholdStores: string,
    bopisHolidayTiming: number,
  }),
  // eslint-disable-next-line react/forbid-prop-types
  directData: object,
  // eslint-disable-next-line react/forbid-prop-types
  applianceDirectData: object,
  configurableApplianceItemIds: arrayOf(string),
  isBuyBoxLite: bool,
  isCartTiles: bool,
  // eslint-disable-next-line react/forbid-prop-types
  localizerStoreDetails: object,
  quantityExceeded: bool,
  // eslint-disable-next-line react/forbid-prop-types
  addOnsAssemblyAndMore: object,
  cartAction: string,
  bypassQuantitySkip: bool,
  category: string,
  lineItemId: string,
  disableSTH: bool,
  disableBODFS: bool,
  disableBOSS: bool,
  openApplianceCheckAvailability: func,
  disablePickupNearBy: bool,
  currentSelectedFulfillment: string,
  leadTime: number,
  hasCustomATC: bool,
  configurableProductDetails: shape({
    isSpecialOrder: bool,
    configuratorHideQuantity: bool,
    isConfigurableBlinds: bool,
    disableTimer: bool
  }),
  hideShippingThreshold: bool
};

FulfillmentTiles.defaultProps = {
  quantity: 1,
  originalConfigId: null,
  storeId: null,
  deliveryZip: '',
  covidAlert: false,
  onChange: () => {},
  onDeliveryZipCodeChange: () => {},
  dualPath: false,
  thresholds: {},
  directData: null,
  applianceDirectData: null,
  configurableApplianceItemIds: null,
  isBuyBoxLite: false,
  isCartTiles: false,
  localizerStoreDetails: {},
  quantityExceeded: false,
  addOnsAssemblyAndMore: null,
  cartAction: '',
  bypassQuantitySkip: false,
  category: '',
  lineItemId: '',
  disableSTH: false,
  disableBODFS: false,
  disableBOSS: false,
  openApplianceCheckAvailability: () => {},
  disablePickupNearBy: false,
  currentSelectedFulfillment: '',
  leadTime: 0,
  hasCustomATC: null,
  configurableProductDetails: {
    isSpecialOrder: false,
    configuratorHideQuantity: false,
    isConfigurableBlinds: false,
    disableTimer: false
  },
  hideShippingThreshold: false,
};

FulfillmentTiles.dataModel = extend(CheckAvailability, dataModel);

export { FulfillmentTiles };
